var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#258518", fillRule: "evenodd", d: "M12.75 1.5c2.9 0 5.25 2.686 5.25 6 0 .144-.004.287-.013.428C19.767 8.648 21 10.2 21 12c0 2.486-2.35 4.5-5.25 4.5a5.966 5.966 0 0 1-2.25-.433v4.183a.75.75 0 0 1-.75.75h-1.5a.75.75 0 0 1-.75-.75v-4.255a5.25 5.25 0 1 1-2.842-9.962C8.231 3.428 10.293 1.5 12.75 1.5z" })
  );
});